import { render, staticRenderFns } from "./AddTagModal.vue?vue&type=template&id=17f5ab60&scoped=true&"
import script from "./AddTagModal.vue?vue&type=script&lang=js&"
export * from "./AddTagModal.vue?vue&type=script&lang=js&"
import style0 from "./AddTagModal.vue?vue&type=style&index=0&id=17f5ab60&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f5ab60",
  null
  
)

export default component.exports